import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e7f77cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "_starContainer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_star = _resolveComponent("icon-star")!
  const _component_icon_star_half = _resolveComponent("icon-star-half")!
  const _component_icon_star_full = _resolveComponent("icon-star-full")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.value == 0)
      ? (_openBlock(), _createBlock(_component_icon_star, {
          key: 0,
          width: _ctx.size,
          height: _ctx.size
        }, null, 8, ["width", "height"]))
      : _createCommentVNode("", true),
    (_ctx.value == 0.5)
      ? (_openBlock(), _createBlock(_component_icon_star_half, {
          key: 1,
          width: _ctx.size,
          height: _ctx.size
        }, null, 8, ["width", "height"]))
      : _createCommentVNode("", true),
    (_ctx.value >= 1)
      ? (_openBlock(), _createBlock(_component_icon_star_full, {
          key: 2,
          width: _ctx.size,
          height: _ctx.size
        }, null, 8, ["width", "height"]))
      : _createCommentVNode("", true),
    (_ctx.value <= 1)
      ? (_openBlock(), _createBlock(_component_icon_star, {
          key: 3,
          width: _ctx.size,
          height: _ctx.size
        }, null, 8, ["width", "height"]))
      : _createCommentVNode("", true),
    (_ctx.value == 1.5)
      ? (_openBlock(), _createBlock(_component_icon_star_half, {
          key: 4,
          width: _ctx.size,
          height: _ctx.size
        }, null, 8, ["width", "height"]))
      : _createCommentVNode("", true),
    (_ctx.value >= 2)
      ? (_openBlock(), _createBlock(_component_icon_star_full, {
          key: 5,
          width: _ctx.size,
          height: _ctx.size
        }, null, 8, ["width", "height"]))
      : _createCommentVNode("", true),
    (_ctx.value <= 2)
      ? (_openBlock(), _createBlock(_component_icon_star, {
          key: 6,
          width: _ctx.size,
          height: _ctx.size
        }, null, 8, ["width", "height"]))
      : _createCommentVNode("", true),
    (_ctx.value == 2.5)
      ? (_openBlock(), _createBlock(_component_icon_star_half, {
          key: 7,
          width: _ctx.size,
          height: _ctx.size
        }, null, 8, ["width", "height"]))
      : _createCommentVNode("", true),
    (_ctx.value >= 3)
      ? (_openBlock(), _createBlock(_component_icon_star_full, {
          key: 8,
          width: _ctx.size,
          height: _ctx.size
        }, null, 8, ["width", "height"]))
      : _createCommentVNode("", true),
    (_ctx.value <= 3)
      ? (_openBlock(), _createBlock(_component_icon_star, {
          key: 9,
          width: _ctx.size,
          height: _ctx.size
        }, null, 8, ["width", "height"]))
      : _createCommentVNode("", true),
    (_ctx.value == 3.5)
      ? (_openBlock(), _createBlock(_component_icon_star_half, {
          key: 10,
          width: _ctx.size,
          height: _ctx.size
        }, null, 8, ["width", "height"]))
      : _createCommentVNode("", true),
    (_ctx.value >= 4)
      ? (_openBlock(), _createBlock(_component_icon_star_full, {
          key: 11,
          width: _ctx.size,
          height: _ctx.size
        }, null, 8, ["width", "height"]))
      : _createCommentVNode("", true),
    (_ctx.value <= 4)
      ? (_openBlock(), _createBlock(_component_icon_star, {
          key: 12,
          width: _ctx.size,
          height: _ctx.size
        }, null, 8, ["width", "height"]))
      : _createCommentVNode("", true),
    (_ctx.value == 4.5)
      ? (_openBlock(), _createBlock(_component_icon_star_half, {
          key: 13,
          width: _ctx.size,
          height: _ctx.size
        }, null, 8, ["width", "height"]))
      : _createCommentVNode("", true),
    (_ctx.value == 5)
      ? (_openBlock(), _createBlock(_component_icon_star_full, {
          key: 14,
          width: _ctx.size,
          height: _ctx.size
        }, null, 8, ["width", "height"]))
      : _createCommentVNode("", true)
  ]))
}